import React from 'react'

import styles from './style.module.css'

export type PaginationSummaryProps = {
  /** 総件数 */
  totalCount: number
  /** 現在ページ（1 始まり） */
  page: number
  /** 1 ページあたりの件数 */
  perPage: number
}

/**
 * 「N件 X-Y件を表示中」の件数サマリー表示。
 * 表示範囲（start/end）は totalCount / page / perPage から内部計算する。
 * デザインは予約者（限定）追加画面のページャーに準拠（件数 22px 太字 / テキスト 14px）。
 */
export const PaginationSummary: React.FC<PaginationSummaryProps> = ({
  totalCount,
  page,
  perPage,
}) => {
  const start = totalCount === 0 ? 0 : (page - 1) * perPage + 1
  const end = Math.min(page * perPage, totalCount)

  return (
    <span className={styles.text}>
      <strong>{totalCount}</strong>件 {start}-{end}件を表示中
    </span>
  )
}
